<template>
    <div className="App">
      <div className="canvas-wrapper">
        <canvas id="oni-mansion-game"></canvas>
      </div>
    </div>
</template>
<style scoped>
</style>
<script src="./OniMansionGame.js"></script>